import isWithinInterval from 'date-fns/isWithinInterval'
import parseISO from 'date-fns/parseISO'
import addDays from 'date-fns/addDays'
import axios from 'axios'
import buildTree from '../js/buildTree'
import { serverUrl } from '../js/config'
import getAuthHeader from '../util/getAuthHeader'

export default {
  FETCH_PRODUCTS: ({ commit, state }, { category = '', page = 1 }) => {
    let query = '?'
    const filters = {
      perPage: state.pagination.perPage,
      orderBy: state.orderBy,
      orderByDirection: state.orderByDirection,
      category,
    }
    Object.keys(filters).forEach((key) => {
      const filter = filters[key]
      query += `${key}=${filter}&`
    })
    query += `page=${page}`
    return axios
      .get(`${serverUrl}/api/v1/products${query}`)
      .then((response) => {
        commit('updateProducts', response.data)
      })
      .catch(() => {
        // console.log(error.response)
      })
  },
  FETCH_COUNTRIES({ commit }) {
    return axios
      .get(`${serverUrl}/api/v1/countries`)
      .then((response) => {
        // krajiny
        commit('setCountries', response.data.countries)
      })
      .catch(() => {
        // console.log(error.response)
      })
  },
  FETCH_PRODUCT: ({ commit, state }, { slug }) => {
    // on the client, the store itself serves as a cache.
    // only fetch items that we do not already have
    // Check if product is already cached
    const item = state.productsCache[slug]
    if (!item) {
      console.log('url', `${serverUrl}/api/v1/product/slug/${slug}`)
      return axios
        .get(`${serverUrl}/api/v1/product/slug/${slug}`)
        .then((response) => commit('SET_PRODUCT', { product: response.data }))
        .catch(() => {
          // console.log(error.response)
        })
    }
    return Promise.resolve()
  },
  FETCH_STORE_CATEGORIES: ({ commit }) =>
    axios
      .get(`${serverUrl}/api/v1/categories`)
      .then((response) => {
        // kategorie
        commit('setCategories', response.data.categories)
        const categoriesTree = buildTree(response.data.categories, 0)
        commit('setCategoriesTree', categoriesTree)
      })
      .catch(() => {
        // console.log(error.response)
      }),
  FETCH_INDEX_DATA: ({ commit }) =>
    axios
      .get(`${serverUrl}/api/v1/index`)
      .then((response) => {
        // bestsellery
        commit('setBestsellers', response.data.bestsellers)

        // novinky
        commit('setLatestProducts', response.data.latestProducts)
      })
      .catch(() => {
        // console.log(error.response)
      }),
  // FETCH_INDEX_DATA: ({ commit, dispatch, state }) => {
  //   console.log('fetch index data')
  //   axios.get(serverUrl + '/api/v1/index')
  //   .then((response) => {
  //     // kategorie
  //     commit('setCategories', response.data.categories)
  //     let categoriesTree = buildTree(response.data.categories, 0)
  //     commit('setCategoriesTree', categoriesTree)

  //     // bestsellery
  //     commit('setBestsellers', response.data.bestsellers)

  //     // novinky
  //     commit('setLatestProducts', response.data.latestProducts)
  //   })
  //   .catch((error) => {
  //     console.log(error.response)
  //   })
  // },
  SIGN_OUT({ commit, state }) {
    if (state.user.discount > 0) {
      commit('removeCustomerDiscountFromCart')
    }
    commit('clearUserData')
  },
  searchProducts({ commit }, search) {
    commit('setCurrentSearch', search)
    if (search !== '') {
      axios
        .get(`${serverUrl}/api/v1/search/${search}`)
        .then((response) => {
          console.log('response', response.data)
          commit('setSearchResult', response.data)
        })
        .catch(() => {
          // console.log(error.response)
        })
    }
  },
  loadAdminData({ commit }) {
    axios
      .get(`${serverUrl}/api/v1/admin/admin_data`, {
        headers: getAuthHeader(),
      })
      .then((response) => {
        commit('setAdminData', response.data)
      })
      .catch((error) => {
        if (error.response) {
          if (
            error.response.status === 400 ||
            error.response.status === 401 ||
            error.response.status === 403
          ) {
            this.commit('clearUserData')
          }
        }
      })
  },
  getAdminProducts({ commit, state }) {
    let query = '?active=all'
    query += `&page=${state.route.params.page ? state.route.params.page : 1}`
    axios
      .get(`${serverUrl}/api/v1/admin/products${query}`, {
        headers: getAuthHeader(),
      })
      .then((response) => {
        commit('updateProducts', response.data)
      })
      .catch(() => {
        // console.log(error.response)
      })
  },
  changePerPage({ commit, state }, perPage) {
    if (state.pagination.perPage !== perPage) {
      commit('changePerPage', perPage)
    }
  },
  changeOrderByDirection({ commit, state }, direction) {
    if (state.orderByDirection !== direction) {
      commit('changeOrderByDirection', direction)
    }
  },
  changeCategory({ commit, state }, category) {
    if (state.route.params.category !== category) {
      commit('changeCategory', category)
    }
  },
  changeOrderBy({ commit, state }, orderBy) {
    if (state.orderBy !== orderBy) {
      commit('changeOrderBy', orderBy)
    }
  },
  changePage({ commit, state }, page) {
    if (state.pagination.currentPage !== page) {
      commit('changePage', page)
    }
  },
  addToCart({ commit, state }, product) {
    const now = Date.now()
    product.defaultItemPrice = product.price
    product.usedCustomerDiscount = false

    if (
      product.discountPrice &&
      isWithinInterval(now, {
        start: parseISO(product.discountPriceActiveFrom),
        end: addDays(parseISO(product.discountPriceActiveUntil), 1),
      })
    ) {
      product.usedItemPrice = product.discountPrice
    } else if (state.user.discount) {
      product.usedItemPrice =
        (product.price * (100 - state.user.discount)) / 100
      product.usedCustomerDiscount = true
    } else {
      product.usedItemPrice = product.price
    }
    commit('addToCart', product)
  },
  loadAdminProducts({ commit, state }, context) {
    let query = '?'
    const mainCategories = state.categories.filter(
      (category) => category.parent_id === null || category.parent_id === 0,
    )
    Object.keys(state.adminProductsPagination.filters).forEach((key) => {
      const filter = state.adminProductsPagination.filters[key]
      // selectedCategory holds the position in mainCategories, but the API
      // expects the category id
      if (key === 'selectedCategory' && filter !== 'all') {
        query += `${key}=${mainCategories[filter].id}&`
      } else {
        query += `${key}=${filter}&`
      }
    })
    const page = state.route.params.page ? state.route.params.page : 1
    query += `page=${page}`
    axios
      .get(`${serverUrl}/api/v1/admin/products${query}`, {
        headers: getAuthHeader(),
      })
      .then((response) => {
        context.loading = false
        commit('setAdminProducts', response.data.data)
        commit('updateAdminProductsPagination', {
          currentPage: response.data.pagination.current_page,
          lastPage: response.data.pagination.last_page,
          perPage: response.data.pagination.per_page,
          total: response.data.pagination.total,
        })
      })
      .catch((error) => {
        if (error.response) {
          if (
            error.response.status === 400 ||
            error.response.status === 401 ||
            error.response.status === 403
          ) {
            commit('clearUserData')
          }
        }
      })
  },
}
